import { Box, HStack } from '@mybridge/ui';
import { Image } from '@mybridge/ui/image';
import { VideoPlayer } from '@mybridge/ui/video-player';
import { useContext, useEffect, useRef, useState } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PostBoxContext } from '../context';
import styles from './media-player.module.scss';

export const ModalMediaDisplay = ({ fullScreen = false, zoom }) => {
  const { post, currentMediaToShow } = useContext(PostBoxContext);
  const { media, child_posts } = post;
  const imgRef = useRef();
  const gifRef = useRef();

  const [slides_, setSlides_] = useState([]);

  const isVideoFile = (file = '') => {
    const lowerFile = file.toLowerCase();
    return lowerFile.includes('.mp4') || lowerFile.includes('.mov');
  };

  const pushSlidesFromPost = (postItem, targetSlides) => {
    if (!postItem) return;

    if (postItem?.gif) {
      targetSlides.push({ type: 'gif', src: postItem.gif });
    }

    for (const mediaItem of postItem?.media ?? []) {
      const { file, type } = mediaItem ?? {};
      if (!file) continue;

      if (type === 'GIF') {
        if (!postItem?.gif) {
          targetSlides.push({ type: 'gif', src: file });
        }
        continue;
      }

      targetSlides.push({
        type: isVideoFile(file) ? 'video' : 'image',
        src: file,
      });
    }
  };

  const prepareMedia = async () => {
    const nextSlides = [];

    pushSlidesFromPost(post, nextSlides);

    for (const child of child_posts ?? []) {
      pushSlidesFromPost(child, nextSlides);
    }

    setSlides_(nextSlides);
  };

  const prepareCurrentSelectedMedia = async () => {
    if (!currentMediaToShow) return;

    const nextSlides = [];

    if (Array.isArray(currentMediaToShow)) {
      for (const item of currentMediaToShow) {
        const file = item?.file;
        if (!file) continue;

        nextSlides.push({
          type: item?.type === 'GIF' ? 'gif' : isVideoFile(file) ? 'video' : 'image',
          src: file,
        });
      }
    } else if (typeof currentMediaToShow === 'string') {
      nextSlides.push({
        type: isVideoFile(currentMediaToShow) ? 'video' : 'image',
        src: currentMediaToShow,
      });
    }

    setSlides_(nextSlides);
  };

  useEffect(() => {
    if (currentMediaToShow) {
      prepareCurrentSelectedMedia();
    } else {
      prepareMedia();
    }
  }, [media, child_posts, currentMediaToShow]);

  useEffect(() => {
    adjustHeight(imgRef);
  }, [imgRef?.current]);

  useEffect(() => {
    adjustHeight(gifRef);
  }, [gifRef?.current]);

  const adjustHeight = (ref) => {
    if (ref.current) {
      const parentRect = ref?.current?.parentElement?.getBoundingClientRect?.();
      ref.current.style.objectFit = 'contain';

      if (ref.current.height >= parentRect?.height) {
        ref.current.style.width = 'auto';
        ref.current.style.height = parentRect?.height + 'px';
      }

      if (ref.current.width >= parentRect?.width) {
        ref.current.style.height = 'auto';
        ref.current.style.width = parentRect?.width + 'px';
      }
    }
  };

  const renderSlide = (slide, index) => {
    if (slide?.type === 'video') {
      return (
        <Box
          h="100vh"
          w="100%"
          style={{
            transform: `scale(${zoom})`,
            transformOrigin: 'center center',
          }}
        >
          <VideoPlayer
            wrapperProps={{ height: '100%', width: '100%' }}
            src={slide?.src}
            height="100%"
            width="100%"
            style={{
              backgroundColor: 'black',
              maxHeight: '100vh',
              width: '100%',
              height: '100%',
            }}
            className={styles.mediaPlayer}
          />
        </Box>
      );
    }

    const imageProps = {
      alt: '',
      src: slide?.src,
      key: index,
      style: {
        objectFit: 'contain',
        transform: `scale(${zoom})`,
      },
    };

    if (slide?.type === 'gif') {
      return fullScreen ? (
        <Image alt="" key="0" h="100vh" src={slide?.src} style={imageProps.style} />
      ) : (
        <Image alt="" key="1" ref={gifRef} w="100%" src={slide?.src} style={imageProps.style} />
      );
    }

    return fullScreen ? (
      <Image {...imageProps} maxH="100vh" alt='' w="100%" />
    ) : (
      <Image
        {...imageProps}
        ref={imgRef}
        alt=''
        /* h="100vh" */
        h="100%"
        maxH="100%"
        w="100%"
      />
    );
  };

  return (
    <>
      {slides_?.length > 1 ? (
        /* <Swiper navigation modules={[Navigation]} slidesPerView={1}> */
        <Swiper navigation modules={[Navigation]} slidesPerView={1} style={{ height: '100%', width: '100%' }}>
          {slides_?.map?.((slide, index) => (
            <SwiperSlide key={index}>
              {slide?.type === 'video' ? (
                <Box
                  h="100vh"
                  w="100%"
                  style={{
                    transform: `scale(${zoom})`,
                    transformOrigin: 'center center',
                  }}
                >
                  <VideoPlayer
                    wrapperProps={{ height: '100%', width: '100%' }}
                    src={slide?.src}
                    height="100%"
                    width="100%"
                    style={{
                      backgroundColor: 'black',
                      maxHeight: '100vh',
                      width: '100%',
                      height: '100%',
                    }}
                    className={styles.mediaPlayer}
                  />
                </Box>
              ) : (
                <HStack
                  userSelect="none"
                  /* h="100vh" */
                  h="100%"
                  maxH="100%"
                  alignItems="center"
                  justifyContent="center"
                  overflow="hidden"
                >
                  <Image
                    alt=""
                    w="100%"
                    /* maxH="100vh" */
                    maxH="100%"
                    h="100%"
                    src={slide?.src}
                    key={index}
                    style={{
                      objectFit: 'contain',
                      transform: `scale(${zoom})`,
                    }}
                  />
                </HStack>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      ) : slides_?.length ? (
        renderSlide(slides_[0], 0)
      ) : (
        ''
      )}
    </>
  );
};
